import * as z from 'zod';

export const priceFrequencyQueryLinkerSchema = z.object({
  id: z.number(),
  name: z.string(),
});

export type PriceFrequencyQueryLinkerSchema = z.infer<typeof priceFrequencyQueryLinkerSchema>;
